/* FM Geo M2 — generic swipable carousel (arrows + progress bar). No deps. */
(function () {
  function init(root) {
    if (!root || root.dataset.fmCarInit === '1') return;
    root.dataset.fmCarInit = '1';

    var track = root.querySelector('[data-fm-carousel-track]');
    if (!track) return;
    var prev = root.querySelector('[data-fm-carousel-prev]');
    var next = root.querySelector('[data-fm-carousel-next]');
    var bar = root.querySelector('[data-fm-carousel-bar]');

    function step() {
      var slide = track.querySelector('.fm-geo-m2-carousel__slide');
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap || '0') || 0;
      if (slide) return slide.getBoundingClientRect().width + gap;
      return track.clientWidth * 0.85;
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (bar) {
        var ratio = track.scrollWidth > 0 ? track.clientWidth / track.scrollWidth : 1;
        var w = Math.max(0.14, Math.min(1, ratio));
        var pos = max > 0 ? track.scrollLeft / max : 0;
        bar.style.width = (w * 100) + '%';
        bar.style.left = (pos * (1 - w) * 100) + '%';
      }
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    }

    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener('resize', function () {
      window.requestAnimationFrame(update);
    });
    update();
    autoplay(root, track, step);
  }

  /* Opt-in per instance via data-fm-carousel-autoplay="<ms>". Yields to the
     visitor: pauses on hover and keyboard focus, backs off after any touch,
     drag or wheel, and idles while off-screen or on a hidden tab. */
  function autoplay(root, track, step) {
    var delay = parseInt(root.getAttribute('data-fm-carousel-autoplay'), 10);
    if (!delay || delay < 1000) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var hovered = false;
    var visible = true;
    var holdUntil = 0;
    var BACKOFF = 6000;

    root.addEventListener('mouseenter', function () { hovered = true; }, { passive: true });
    root.addEventListener('mouseleave', function () { hovered = false; }, { passive: true });
    ['pointerdown', 'touchstart', 'wheel', 'focusin'].forEach(function (evt) {
      root.addEventListener(evt, function () { holdUntil = Date.now() + BACKOFF; }, { passive: true });
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
      }, { threshold: 0.2 }).observe(root);
    }

    setInterval(function () {
      if (hovered || !visible || document.hidden || Date.now() < holdUntil) return;
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 2) return;
      if (track.scrollLeft >= max - 2) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      }
    }, delay);
  }

  function boot() { document.querySelectorAll('[data-fm-carousel]').forEach(init); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
